<template>
  <div class="warehouse" ref="container">
    <!-- <div class="title" v-if="th_max_tips">{{ th_max_tips }}</div> -->
    <div class="list">
      <div
        v-for="(item, index) in list"
        :key="index"
        @click="
          $router.push(
            '/user/stocklog/' + item.pid + '/' + item.unique + '?yc_type=0'
          )
        "
        class="item acea-row row-between-wrapper"
      >
        <div>
          <div class="acea-row row-middle">
            <img :src="item.image" alt="" style="width: 20vw;height: 20vw;" />
            <div class="infos">
              <div class="store_name">{{ item.store_name }}</div>
              <div class="rule">{{ item.suk }}</div>
              <div class="num">库存：{{ item.num }}</div>
            </div>
          </div>
        </div>
        <div class="btn3" @click.stop="item.show = !item.show">
          {{ item.show ? "收起操作" : "更多操作" }}
        </div>

        <div class="btns4">
          <div v-if="!item.show" style="background-color: #fff;"></div>
          <div v-if="!item.show" style="background-color: #fff;"></div>
          <div
            class="btn1"
            v-if="!item.show"
            @click.stop="
              $router.push('/user/stockdetail/' + item.id + '/1' + '?yc_type=0')
            "
          >
            提货
          </div>
        </div>
        <div class="btns" v-if="item.show">
          <div
            class="btn1"
            @click.stop="
              $router.push('/user/stockdetail/' + item.id + '/1' + '?yc_type=0')
            "
          >
            提货
          </div>
          <div
            class="btn2"
            @click.stop="
              $router.push('/user/stockdetail/' + item.id + '/4' + '?yc_type=0')
            "
          >
            自提
          </div>
        </div>
        <div class="btns" v-if="item.show">
          <div
            class="btn2"
            @click.stop="
              $router.push('/user/stockdetail/' + item.id + '/2' + '?yc_type=0')
            "
          >
            转赠
          </div>
          <div
            v-if="item.type == 2"
            class="btn2"
            @click.stop="
              $router.push(
                '/order/cart?price=' +
                  item.price +
                  '&num=' +
                  item.num +
                  '&pid=' +
                  item.pid +
                  '&unique=' +
                  item.unique +
                  '&yc_type=0&img=' +
                  item.image
              )
            "
          >
            换货
          </div>
        </div>
        <div class="btns" v-if="item.show">
          <div v-if="!item.show" style="background-color: #fff;"></div>
          <div
            class="btn2"
            style="width: 70vw;"
            @click.stop="
              $router.push(
                '/user/stocklog/' + item.pid + '/' + item.unique + '?yc_type=0'
              )
            "
          >
            云仓记录
          </div>
          <div v-if="!item.show" style="background-color: #fff;"></div>
        </div>
      </div>
    </div>
    <div class="nolist" v-if="list.length == 0">暂无数据</div>
  </div>
</template>
<script>
import { stockList } from "../../api/order";
import { other } from "@api/public";
export default {
  name: "warehouse",
  data() {
    return {
      page: 1,
      limit: 10,
      loading: false,
      loadend: false,
      list: [],
      th_max_tips: ""
    };
  },
  mounted() {
    this.getlist();
    this.other();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getlist();
    });
  },
  methods: {
    other() {
      other().then(res => {
        this.th_max_tips = res.data.th_max_tips;
      });
    },
    godetail(item) {
      console.log(item);
    },
    getlist() {
      if (this.loading) return;
      if (this.loadend) return;
      let data = {
        page: this.page,
        limit: this.limit,
        yc_type: 0
      };
      this.loading = true;
      stockList(data)
        .then(res => {
          let list = res.data.map(item => {
            return {
              ...item,
              show: false
            };
          });
          this.th_max_tips = res.data.th_max_tips;
          this.loading = false;
          this.loadend = this.limit > res.data.length;
          this.page++;
          this.list = this.list.concat(list);
          console.log(this.list);
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.warehouse {
  .list {
    padding: 0 4vw;

    .item {
      position: relative;
      padding: 3vw;
      background: #ffffff;
      border-radius: 2vw;
      margin-bottom: 3vw;
      .btn3 {
        position: absolute;
        right: 0.2rem;
        top: 0.4rem;
        width: 20vw;
        height: 10vw;
        line-height: 10vw;
        font-size: 4vw;
        border-radius: 3vw;
        color: #ffffff;
        background: #0e98fd;
        text-align: center;
      }
      img {
        width: 15vw;
        height: 15vw;
        margin-right: 2vw;
      }
      .infos {
        height: 20vw;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .store_name {
          width: 3rem;
          font-size: 4vw;
          font-weight: 600;
          flex-wrap: wrap;
        }
        .rule {
          font-size: 3.73vw;
        }
        .num {
          color: #666;
          color: #999;
        }
      }
    }
    .btns {
      width: 100%;
      display: flex;
      margin-top: 0.1rem;
      justify-content: space-around;
      > div {
        // margin-bottom: 2vw;
        width: 40vw;
        height: 10vw;
        line-height: 10vw;
        font-size: 4vw;
        border-radius: 3vw;
        color: #ffffff;
        background: #0e98fd;
        text-align: center;
        margin-bottom: 0.1rem;
      }
    }
    .btns4 {
      width: 100%;
      display: flex;
      margin-top: 0.1rem;
      justify-content: space-between;
      > div {
        // margin-bottom: 2vw;
        width: 20vw;
        height: 10vw;
        line-height: 10vw;
        font-size: 4vw;
        border-radius: 3vw;
        color: #ffffff;
        background: #0e98fd;
        text-align: center;
      }
    }
    .nolist {
      text-align: center;
      line-height: 20vw;
      color: #999;
    }
  }
}
.title {
  height: 0.8rem;
  width: 100%;
  background-color: #0e98fd;
  line-height: 0.8rem;
  text-align: center;
  margin-bottom: 0.2rem;
  color: #fff;
}
</style>
